const PERMISSION_KEY= "console:service_register";
const PAGE_URL = {
    SERVICE_REGISTER_PAGE: "/admin/console/service-register"
}

export {PERMISSION_KEY, PAGE_URL}

